import type { Routes } from '@angular/router';

export const AGGREGATED_BOOSTERS_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#shell/layouts/logged-in-layout/groups/aggregated-boosters-layout/aggregated-boosters-layout.component').then(
                (m) => m.AggregatedBoostersComponent
            ),
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'wheels-of-fortune',
            },
            {
                path: 'wheels-of-fortune',
                loadChildren: () =>
                    import('#modules/wheels-of-fortune/routes/logged-in-aggregated-wheels-of-fortune.routing').then(
                        (m) => m.AGGREGATED_WHEELS_OF_FORTUNE_ROUTES
                    ),
            },
            {
                path: 'presentation',
                loadChildren: () =>
                    import('#modules/boosters/routes/aggregated-boosters-presentation.routing').then(
                        (m) => m.AGGREGATED_BOOSTERS_PRESENTATION_ROUTES
                    ),
            },
        ],
    },
];
